import { SvgIcon, SvgIconProps } from "@mui/material";

export const IntegrationsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="integrations"
    >
      <path
        stroke="#E4C468"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m10 13 .953.954a4.001 4.001 0 0 0 5.659 0l3.032-3.033a4.643 4.643 0 0 0 0-6.565v0a4.643 4.643 0 0 0-6.565 0l-.888.888"
      />
      <path
        stroke="#E4C468"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m14 10-.953-.954a4.001 4.001 0 0 0-5.659 0l-3.032 3.032a4.643 4.643 0 0 0 0 6.566v0a4.643 4.643 0 0 0 6.566 0l.887-.889"
      />
    </svg>
    ;
  </SvgIcon>
);
